import React from 'react'
import styles from '../../styles/LittleCard.module.scss'

const LittleCard = ({children}) => {
  return (
    <div className={styles.card}>
      {children}
    </div>
  )
}

export default LittleCard
